import { useEffect } from "react";
import { SortCardStyle } from "./SortFilter.Style";
import { IoSwapVerticalSharp } from "react-icons/io5";

const SortCard = ({
  detailsList,
  title,
  setFilterValue,
  filterValue,
  setSortParams,
  setSortOrder,
  visible
}) => {

  useEffect(() => {
    if (filterValue === "Detail (A-Z)") {
      setSortOrder(0);
      setSortParams(1);
    } else if (filterValue === "Detail (Z-A)") {
      setSortOrder(1);
      setSortParams(1);
    } else if (filterValue === "Status (A-Z)") {
      setSortOrder(0);
      setSortParams(0);
    } else if (filterValue === "Status (Z-A)") {
      setSortOrder(1);
      setSortParams(0);
    } else if (filterValue === "Reporting date (Earliest to Latest)") {
      setSortOrder(0);
      setSortParams(2);
    } else if (filterValue === "Reporting date (Latest to Earliest)") {
      setSortOrder(1);
      setSortParams(2);
    } else if (filterValue === "Resolution date (Earliest to Latest)") {
      setSortOrder(0);
      setSortParams(3);
    } else if (filterValue === "Resolution date (Latest to Earliest)") {
      setSortOrder(1);
      setSortParams(3);
    }
    // eslint-disable-next-line
  }, [filterValue]);
  
  return (
    <div>
      <div className="container">
        <div className="item-container">
          <span className="title">{filterValue ? filterValue : title}</span>
        </div>
        <div className="icon-style">
          <IoSwapVerticalSharp />
        </div>
      </div>

      {visible ? (
        <div>
          <SortCardStyle>
            {detailsList.map((value, index) => (
              <div
                className="list-item"
                key={index}
                onClick={() => setFilterValue(value)}
              >
                {value}
              </div>
            ))}
          </SortCardStyle>
        </div>
      ) : null}
    </div>
  );
};

export default SortCard;
